import { useEffect, useState } from "react";

/**
 * Returns true when the app is running as an installed PWA
 * (Android/Chrome standalone display-mode, or iOS Safari home-screen mode).
 * Reactively updates if the mode changes (rare but possible).
 */
export default function useStandalone() {
  const detect = () => {
    if (typeof window === "undefined") return false;
    const mm = window.matchMedia?.("(display-mode: standalone)").matches;
    const ios = window.navigator?.standalone === true;
    return Boolean(mm || ios);
  };
  const [isStandalone, setIsStandalone] = useState(detect);

  useEffect(() => {
    const mq = window.matchMedia?.("(display-mode: standalone)");
    if (!mq) return;
    const handler = () => setIsStandalone(detect());
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, []);

  return isStandalone;
}
